import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { ActivityLabelFormInput } from "../components/CreateActivityLabelModal";
import {
  ActivityLabel,
  GET_ACTIVITY_LABELS_FETCH_KEY,
} from "@/shared/core-activity-labels";

export const createActivityLabel = async (
  newActivityLabel: Partial<ActivityLabelFormInput>,
): Promise<ActivityLabel> => {
  const response = await fetcher.post(
    `${API.GESLUB}/zone-activity-label`,
    newActivityLabel,
  );
  return response.data;
};

export const useCreateActivityLabel = () => {
  const queryClient = useQueryClient();

  return useMutation<ActivityLabel, Error, Partial<ActivityLabelFormInput>>({
    mutationFn: createActivityLabel,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ACTIVITY_LABELS_FETCH_KEY],
      });
    },
    onError: (error) => {
      console.error("Error creando etiqueta de actividad:", error);
    },
  });
};
